<button class="notificationsDropDownButton"
        [ngClass]="{'hasUnread': hasUnread}"
        [attr.aria-label]="notificationsTooltipText"
        [matTooltip]="notificationsTooltipText"
        (click)="showNotifications()"
>
  <mat-icon fontSet="material-icons-outlined">notifications</mat-icon>
</button>
<div class="hiddenMenu" [ngClass]="{'open': expanded}">
  <ng-scrollbar style="max-height: 500px;" [autoHeightDisabled]="false">
    <ul class="notificationsList" role="menu">
      @for (notification of notifications; track notification) {
        <li role="menuitem">
          @if (notification.routerLink) {
            <a
              [routerLink]="notification.routerLink"
              [queryParams]="notification.queryParams"
              tabindex=0
              (click)="closeMenuEvent()"
            >
              <div class="notification_date">{{notification.notificationDate | date:'fullDate'}}</div>
              <div class="notification_content">{{notification.description}}</div>
              <div class="notification_readMore">View</div>
            </a>
          }
          @if (!notification.routerLink) {
            <div>
              <div class="notification_date">{{notification.notificationDate | date:'fullDate'}}</div>
              <div class="notification_content">{{notification.description}}</div>
            </div>
          }
        </li>
      }
      @if (notifications.length == 0) {
        <li role="menuitem">
          You have no new notifications
        </li>
      }
    </ul>
  </ng-scrollbar>
</div>
